module.exports = __webpack_public_path__ + "img/homepage-background.dd05bbe.jpeg";